var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#1A78F3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Video Player",
    id: "Video_Player"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1.03,
    width: 30,
    x: 1,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.03,
    width: 30,
    x: 1,
    y: 29.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,5.66V26.34H31V5.66ZM21.33,17.84l-8.47,4.72a2.2,2.2,0,0,1-3.29-1.84V11.28a2.2,2.2,0,0,1,3.29-1.84l8.47,4.72A2.09,2.09,0,0,1,21.33,17.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.55,
    width: 3.21,
    x: 5.82,
    y: 3.07
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.55,
    width: 3.21,
    x: 10.11,
    y: 3.07
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.55,
    width: 3.21,
    x: 14.39,
    y: 3.07
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.55,
    width: 3.21,
    x: 18.68,
    y: 3.07
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.55,
    width: 3.21,
    x: 22.96,
    y: 3.07
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.55,
    width: 3.21,
    x: 5.82,
    y: 27.38
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.55,
    width: 3.21,
    x: 10.11,
    y: 27.38
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.55,
    width: 3.21,
    x: 14.39,
    y: 27.38
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.55,
    width: 3.21,
    x: 18.68,
    y: 27.38
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.55,
    width: 3.21,
    x: 22.96,
    y: 27.38
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoChat);
export default __webpack_public_path__ + "static/media/video_chat.16c2432996fb47e2d481f5ca99517913.svg";
export { ForwardRef as ReactComponent };